import { AnalyticsClient, AnalyticsEvent, EventLevel } from "@App/utils/analytics/interfaces";
import * as Sentry from "@sentry/react";

export const SentryClient: AnalyticsClient = {
  capture({ level, props }: AnalyticsEvent) {
    if (level !== EventLevel.ERROR || !props || !("err" in props)) return;
    if (props.err == null) return;

    const err = props.err;

    if (isGeolocationError(err)) {
      Sentry.withScope((scope) => {
        scope.setTag("error.type", "geolocation");
        scope.setExtra("geolocation.code", err.code);
        scope.setExtra("geolocation.message", err.message);
        Sentry.captureException(new Error(`Geolocation error ${err.code}: ${err.message}`));
      });
      return;
    }

    Sentry.captureException(err instanceof Error ? err : new Error(String(err)));
  },
};

const GEOLOCATION_ERROR_CODES = new Set([
  1, // PERMISSION_DENIED
  2, // POSITION_UNAVAILABLE
  3, // TIMEOUT
]);

function isGeolocationError(err: unknown): err is GeolocationPositionError {
  return (
    typeof err === "object" &&
    err !== null &&
    "code" in err &&
    "message" in err &&
    typeof (err as GeolocationPositionError).code === "number" &&
    GEOLOCATION_ERROR_CODES.has((err as GeolocationPositionError).code) &&
    typeof (err as GeolocationPositionError).message === "string"
  );
}
